import { render, staticRenderFns } from "./UpdateInvestment.vue?vue&type=template&id=22c57716"
import script from "./UpdateInvestment.vue?vue&type=script&lang=js"
export * from "./UpdateInvestment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports